import { render, staticRenderFns } from "./InfractionsHeader.vue?vue&type=template&id=9de0e398&"
import script from "./InfractionsHeader.vue?vue&type=script&lang=js&"
export * from "./InfractionsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports